import { graphql } from 'app/generated/gql'

/**
 * Whether the location has an SMS agent that can actually answer.
 *
 * This is the readiness signal the handoff step and the reply worker gate on
 * (TRK-5676), so gating the Schedule control on it means the UI and the engine
 * agree on what "the agent is live" means. It answers with a Boolean rather
 * than the prompt body, which is why any workspace user may read it.
 *
 * It lives on the OPS schema. Asking the public endpoint for it does NOT error:
 * the field is silently dropped and `data` comes back empty, so a caller that
 * forgot the ops client would read `undefined` forever and the gate would never
 * close. Every caller passes the ops client or the ops url explicitly.
 */
export const SMS_AGENT_READY_QUERY = graphql(`
  query SmsAgentReady($locationId: ID!) {
    smsAgentReady(locationId: $locationId)
  }
`)

export const THREAD_AGENT_STATE_QUERY = graphql(`
  query ThreadAgentState($id: ID!) {
    thread(id: $id) {
      id
      aiEnabled
    }
  }
`)

/**
 * A Thread carries no contact reference, so the only route from a recipient to
 * their thread is one of their messages. Every message on a conversation
 * carries the same `threadId`, so one row per contact is enough.
 */
export const CONTACT_THREAD_IDS_QUERY = graphql(`
  query ContactThreadIds($search: String, $pagination: PaginationInput, $sort: SortInput) {
    messages(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        contactId
        threadId
      }
    }
  }
`)

export const THREADS_AGENT_STATE_QUERY = graphql(`
  query ThreadsAgentState($search: String, $pagination: PaginationInput) {
    threads(search: $search, pagination: $pagination) {
      hits {
        id
        aiEnabled
      }
    }
  }
`)
